/* eslint-disable @typescript-eslint/no-unused-vars */

const SUBSCRIPTION_APPLICATION_MOCKED_PROPS_LOCAL = {
    id: 'subscription',
    instance_id: crypto.randomUUID(),
    src: 'http://localhost:8105/subscription.js',
    module: './Component',
    scope: 'subscription',
    remotes: {
        Serviceability: {
            module: 'serviceability',
            src: 'http://localhost:8100/serviceability.js'
        },
        ManageOffers: {
            module: 'manageOffers',
            src: 'http://localhost:8097/manage-offers.js'
        },
        CustomerIdentification: {
            module: 'customerIdentification',
            src: 'http://localhost:8106/customer-identification.js'
        },
        NumberConfiguration: {
            module: 'numbersConfiguration',
            src: 'http://localhost:8107/numbers-configuration.js'
        },
        ScheduleAppointment: {
            module: 'scheduleAppointment',
            src: 'http://localhost:8099/schedule-appointment.js'
        },
        OfferSummary: {
            module: 'offerSummary',
            src: 'http://localhost:8098/offer-summary.js'
        },
        DocumentSigning: {
            module: 'documentSigning',
            src: 'http://localhost:8102/document-signing.js'
        }
    }
};

const SUBSCRIPTION_APPLICATION_MOCKED_PROPS_NON_LOCAL = {
    id: 'subscription',
    instance_id: crypto.randomUUID(),
    src: 'https://onex-pre.pt.internal.vodafone.com/mfe/journeys/subscription/2.3.0-SNAPSHOT/subscription.js',
    module: './Component',
    scope: 'subscription',
    remotes: {
        Serviceability: {
            module: 'serviceability',
            src: 'https://onex-pre.pt.internal.vodafone.com/mfe/journeys/serviceability/2.3.0-SNAPSHOT/serviceability.js'
        },
        ManageOffers: {
            module: 'manageOffers',
            src: 'https://onex-pre.pt.internal.vodafone.com/mfe/journeys/manage-offers/2.3.0-SNAPSHOT/manage-offers.js'
        },
        CustomerIdentification: {
            module: 'customerIdentification',
            src: 'https://onex-pre.pt.internal.vodafone.com/mfe/journeys/customer-identification/2.3.0-SNAPSHOT/customer-identification.js'
        },
        NumberConfiguration: {
            module: 'numbersConfiguration',
            src: 'https://onex-pre.pt.internal.vodafone.com/mfe/journeys/numbers-configuration/2.3.0-SNAPSHOT/numbers-configuration.js'
        },
        ScheduleAppointment: {
            module: 'scheduleAppointment',
            src: 'https://onex-pre.pt.internal.vodafone.com/mfe/journeys/schedule-appointment/2.3.0-SNAPSHOT/schedule-appointment.js'
        },
        OfferSummary: {
            module: 'offerSummary',
            src: 'https://onex-pre.pt.internal.vodafone.com/mfe/journeys/offer-summary/2.3.0-SNAPSHOT/offer-summary.js'
        },
        DocumentSigning: {
            module: 'documentSigning',
            src: 'https://onex-pre.pt.internal.vodafone.com/mfe/journeys/document-signing/2.3.0-SNAPSHOT/document-signing.js'
        }
    }
};

export const SUBSCRIPTION_APPLICATION_MOCKED_PROPS = SUBSCRIPTION_APPLICATION_MOCKED_PROPS_NON_LOCAL;
